module.exports = __webpack_public_path__ + "img/sjb6_63_100.prt.233ae190.jpg";